/* globals tv */
import { combineEpics } from 'redux-observable';
import { Observable } from 'rxjs';

import * as ActionCreators from '../actions/ActionCreators';
import * as ActionTypes from '../actions/ActionTypes';


export const adsInitializeEpic = (action$, store, { ads }) => action$
    .ofType(ActionTypes.SET_VIDEO_PLAYER_DATA)
    .filter(() => !!store.getState().player.adsEnabled)
    .map(() => ads.setContext(store.getState().videoSource))
    .switchMap((adsContext) => Observable.merge(
        Observable.fromEvent(adsContext, tv.freewheel.SDK.EVENT_AD_CLICK).map((event) => ActionCreators.adsEventClick(event)),
        Observable.fromEvent(adsContext, tv.freewheel.SDK.EVENT_AD_IMPRESSION_END).map((event) => ActionCreators.adsEventImpressionEnded(event)),
        Observable.fromEvent(adsContext, tv.freewheel.SDK.EVENT_AD_IMPRESSION).map((event) => ActionCreators.adsEventImpressionStarted(event)),
        Observable.fromEvent(adsContext, tv.freewheel.SDK.EVENT_ERROR).map((event) => ActionCreators.adsEventError(event)),
        Observable.fromEvent(adsContext, tv.freewheel.SDK.EVENT_REQUEST_COMPLETE).map((event) => ActionCreators.adsEventRequestComplete(event)),
        Observable.fromEvent(adsContext, tv.freewheel.SDK.EVENT_SLOT_ENDED).map((event) => ActionCreators.adsEventSlotEnded(event)),
        Observable.fromEvent(adsContext, tv.freewheel.SDK.EVENT_SLOT_STARTED).map((event) => ActionCreators.adsEventSlotStarted(event)),
    ));


export const adsRequestCompleteEpic = (action$, store, { ads }) => action$
    .ofType(ActionTypes.ADS_EVENT_REQUEST_COMPLETE)
    .filter(data => !!data.payload.success)
    .do(() => ads.setSlots())
    .map(() => ActionCreators.setAdsRequestCompleteState(true));



export const adsSlotStartedEpic = (action$, store, { player, ads }) => action$
    .ofType(ActionTypes.ADS_EVENT_SLOT_STARTED)
    .filter(data => !(data.payload.slot.getTimePositionClass() === tv.freewheel.SDK.TIME_POSITION_CLASS_DISPLAY))
    .map(data => data.payload.slot)
    .do(adSlot => {
        ads.setContextVideoState(tv.freewheel.SDK.VIDEO_STATE_PAUSED);
        player.addClass('ad-loading');

        // trigger on player for external ad listeners
        player.trigger('ad-start', { slot: adSlot, adType: adSlot.getTimePositionClass().toLowerCase() });
    })
    .map(() => ActionCreators.setAdPlayingState(true));


export const adsSlotEndedEpic = (action$, store, { player }) => action$
    .ofType(ActionTypes.ADS_EVENT_SLOT_ENDED)
    .filter(data => !(data.payload.slot.getTimePositionClass() === tv.freewheel.SDK.TIME_POSITION_CLASS_DISPLAY)) // fired from display (sync units)
    .map(data => data.payload.slot)
    .do(adSlot => {
        player.removeClass('ad-loading');

        // trigger on player for external ad listeners
        player.trigger('ad-complete', { slot: adSlot, adType: adSlot.getTimePositionClass().toLowerCase() });
    })
    .map(() => ActionCreators.setAdPlayingState(false));


export const adsSlotForceEnd = (action$, store, { player, ads }) => action$
    .ofType(ActionTypes.SET_VIDEO_PLAYER_DATA)
    .filter(() => store.getState().player.adPlaying) // ad is playing
    .do(() => player.removeClass('ad-playing'))
    .do(() => player.removeClass('ad-loading'))
    .do(() => ads.skipAd())
    .map(() => ActionCreators.setAdPlayingState(false));


export const adsPrerollEndedEpic = (action$, store, { player, ads }) => action$
    .ofType(ActionTypes.ADS_EVENT_SLOT_ENDED)
    .map(data => data.payload.slot.getTimePositionClass())
    .filter(timePositionClass => (timePositionClass === tv.freewheel.SDK.TIME_POSITION_CLASS_PREROLL)) // fired from display (sync units)
    .do(() => {
        ads.prerolls.splice(0, 1);
        if (ads.prerolls.length) {
            if (!!player.tech_.hlsProvider) player.tech_.hlsProvider.dispose();  // dispose of hls source handler to start ads faster
            ads.startPreroll();
        } else ads.setContextVideoState(tv.freewheel.SDK.VIDEO_STATE_PLAYING);
    })
    .map(() => ActionCreators.adsPrerollEnd());


export const adsMidrollEndedEpic = (action$, store, { ads }) => action$
    .ofType(ActionTypes.ADS_EVENT_SLOT_ENDED)
    .map(data => data.payload.slot.getTimePositionClass())
    .filter(timePositionClass => (timePositionClass === tv.freewheel.SDK.TIME_POSITION_CLASS_MIDROLL))
    .do(() => {
        ads.midrolls.splice(0, 1);
        ads.setContextVideoState(tv.freewheel.SDK.VIDEO_STATE_PLAYING);
    })
    .map(() => ActionCreators.adsMidrollEnd());


export const adsPostrollEndedEpic = (action$, store, { player, ads }) => action$
    .ofType(ActionTypes.ADS_EVENT_SLOT_ENDED)
    .map(data => data.payload.slot.getTimePositionClass())
    .filter(timePositionClass => (timePositionClass === tv.freewheel.SDK.TIME_POSITION_CLASS_POSTROLL))
    .do(() => {
        ads.postrolls.splice(0, 1);
        if (ads.postrolls.length) {
            if (!!player.tech_.hlsProvider) player.tech_.hlsProvider.dispose();  // dispose of hls source handler to start ads faster
            ads.startPostroll();
        } else ads.setContextVideoState(tv.freewheel.SDK.VIDEO_STATE_COMPLETED);
    })
    .map(() => ActionCreators.adsPostrollEnd());


export const adsImpressionStartedEpic = (action$, store, { player }) => action$
    .ofType(ActionTypes.ADS_EVENT_IMPRESSION_STARTED)
    .filter(data => !(data.payload.adInstance.getSlot().getTimePositionClass() === tv.freewheel.SDK.TIME_POSITION_CLASS_DISPLAY))
    .do((data) => {
        player.addClass('ad-playing');
        player.removeClass('ad-loading');
    })
    .ignoreElements();


export const adsImpressionEndedEpic = (action$, store, { player }) => action$
    .ofType(ActionTypes.ADS_EVENT_IMPRESSION_ENDED)
    .filter(data => !(data.payload.adInstance.getSlot().getTimePositionClass() === tv.freewheel.SDK.TIME_POSITION_CLASS_DISPLAY))
    .do(() => player.removeClass('ad-playing'))
    .ignoreElements();


export const adsErrorEpic = (action$, store, { }) => action$
    .ofType(ActionTypes.ADS_EVENT_ERROR)
    .ignoreElements();


export const adsClickEpic = (action$, store, { }) => action$
    .ofType(ActionTypes.ADS_EVENT_CLICK)
    .ignoreElements();


// starts preroll for autoplay = true
export const adsAutoStartPrerollEpic = (action$, store, { player, ads }) => action$
    .ofType(ActionTypes.SET_ADS_REQUEST_COMPLETE_STATE)
    .filter(data => data.payload) // when ads request completed
    .filter(() => player.autoplay()) // only start ads right away when autoplay is on
    .filter(() => !!ads.prerolls.length) // only start ads when there are ads from the request
    .do(() => ads.startPreroll())
    .ignoreElements();


// starts preroll for autoplay = false
export const adsStartPrerollEpic = (action$, store, { player, ads }) => action$
    .ofType(ActionTypes.PLAYER_EVENT_PLAY)
    .filter(() => store.getState().player.adRequestComplete) // check if ad request is complete
    .filter(() => !player.autoplay()) // only applies when autoplay is turned off
    .filter(() => !!ads.prerolls.length) // only start ads when there are ads from the request
    .filter(() => (ads.prerolls[0]) && ads.prerolls[0].getAdCount() > 0) // prerolls can have object, but no ads in it
    .do(() => {
        if (!!player.tech_.hlsProvider) player.tech_.hlsProvider.dispose();  // dispose of hls source handler to start ads faster
        ads.startPreroll();
    })
    .ignoreElements();


export const adsMonitorForMidrollsEpic = (action$, store, { player, ads }) => action$
    .ofType(ActionTypes.PLAYER_EVENT_TIME_UPDATE)
    .throttleTime(100)
    .filter(() => !!store.getState().player.adsEnabled)
    .filter(() => !store.getState().player.adPlaying) // only when an ad isn't playing
    .filter(() => store.getState().player.adReturnMidrollTime === -1) // only when return to midroll time is not set
    .filter(() => !!ads.midrolls.length) // only start ads when there are ads from the request
    .map(() => player.currentTime())
    .map((currentTime) => ({ midroll: ads.getMidroll(currentTime), currentTime }))
    .filter((payload) => !!payload.midroll) // don't continue if no slot to play yet
    .do((payload) => {
        if (!!player.tech_.hlsProvider) player.tech_.hlsProvider.dispose();  // dispose of hls source handler to start ads faster
        ads.startMidroll(payload.midroll);
    })
    .map((payload) => ActionCreators.setAdsReturnMidrollTimeState(payload.currentTime));


export const adReturnFromMidrollEpic = (action$, store, { player, ads, options }) => action$
    .ofType(ActionTypes.PLAYER_EVENT_CAN_PLAY_THROUGH)
    .filter(() => !!store.getState().player.adsEnabled) // only applies when ads are on
    .filter(() => !store.getState().player.adPlaying)
    .filter(() => (store.getState().player.adReturnMidrollTime > 0))
    .delay(50)
    .do(() => {
        player.currentTime(store.getState().player.adReturnMidrollTime);
    })
    .map(() => player.currentTime())
    .filter((currentTime) => (currentTime >= store.getState().player.adReturnMidrollTime))
    .map(() => ActionCreators.setAdsReturnMidrollTimeState(-1));


export const adsStartPostrollEpic = (action$, store, { player, ads }) => action$
    .ofType(ActionTypes.PLAYER_EVENT_ENDED)
    .filter(() => !!store.getState().player.adsEnabled) // only applies when ads are on
    .filter(() => !store.getState().player.adPlaying) // when ad not playing
    .filter(() => !!ads.postrolls.length) // only start ads when there are ads from the request
    .do(() => {
        if (!!player.tech_.hlsProvider) player.tech_.hlsProvider.dispose();  // dispose of hls source handler to start ads faster
        ads.startPostroll();
    })
    .ignoreElements();


export default combineEpics(
    adsInitializeEpic,
    adsRequestCompleteEpic,
    adsAutoStartPrerollEpic,
    adsSlotStartedEpic,
    adsStartPrerollEpic,
    adsStartPostrollEpic,
    adsSlotEndedEpic,
    adsPrerollEndedEpic,
    adsMidrollEndedEpic,
    adsPostrollEndedEpic,
    adsImpressionStartedEpic,
    adsImpressionEndedEpic,
    adsErrorEpic,
    adsClickEpic,
    adsMonitorForMidrollsEpic,
    adReturnFromMidrollEpic,
    adsSlotForceEnd,
);













// WEBPACK FOOTER //
// ./src/ads/epics.js